import axios from 'axios';
import logger from '@greenlight/logger';
import datadogRumClient from '../../utils/datadog-rum';
import { getBrowserData } from '../../utils/getBrowserData';

/**
 * Function used to collect and post browser data to risk service.
 */
const getAndLinkBrowserData = async ({ userId, familyUid, ipAddress }) => {
  try {
    const browserData = getBrowserData();
    const payloadRiskId = {
      userId,
      browserData: {
        ip_addresses: [ipAddress],
        ...browserData
      }
    };

    // First call - Getting riskId.
    await axios.post('/api/browser-data', payloadRiskId);
    const payloadLinkRiskId = {
      userId,
      familyUid
    };
    // Second call - Linking riskId.
    await axios.post('/api/browser-data-link', payloadLinkRiskId);
  } catch (error) {
    logger.error('Error calling web-device-data risk server', error);
    datadogRumClient.addError(error);
    // TODO: Should we stop process or redirect to anywhere?
  }
};

export const mapper = async (action, store) => {
  switch (action.type) {
    case 'appLoginSuccess':
      const ipAddress = store.getState().user.ipAddress || '';
      await getAndLinkBrowserData({
        userId: action.payload.user.id,
        familyUid: action.payload.user.familyUid,
        ipAddress
      });
      break;

    case 'appAnswerSuccess':
      if (!!action.payload.extras && action.payload.extras.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const extra of action.payload.extras) {
          if (extra.action === 'create_user' && extra.user && extra.user.id) {
            // eslint-disable-next-line no-await-in-loop
            const ipAddress = store.getState().user.ipAddress || '';
            await getAndLinkBrowserData({
              userId: extra.user.id,
              familyUid: extra.user.familyUid,
              ipAddress
            });
          }
        }
      }
      break;

    default:
      break;
  }
};

const RiskMiddleware = store => next => action => {
  mapper(action, store);
  next(action);
};
export default RiskMiddleware;
